module.exports = __webpack_public_path__ + "img/list3.ed2f13c8.png";